import { Pipe } from '@angular/core';
import { KompaktdarstellungPipe } from '../kompakt-darstellung.pipe';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { PlatformLocation } from '@angular/common';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { GrundbuchgeschaeftRestListEntryMeta } from '../../../core/gb-api/model/grundbuchgeschaeftRestListEntryMeta';
import { GrundbuchgeschaeftListEntryMeta } from '../../../core/gb-api/model/grundbuchgeschaeftListEntryMeta';
import { FormatTimepointPipe } from '../../pipes/format/format-timepoint.pipe';
import { DatumPipe } from '../../pipes/simple/datum.pipe';
import { TranslateService } from '@ngx-translate/core';
import { GrundbuchgeschaeftRestDetailEntryMeta } from '../../../core/gb-api/model/grundbuchgeschaeftRestDetailEntryMeta';

export type GrundbuchgeschaeftItem =
  | GrundbuchgeschaeftRestListEntryMeta
  | GrundbuchgeschaeftListEntryMeta
  | GrundbuchgeschaeftRestDetailEntryMeta;

@Pipe({
  name: 'kompaktGrundbuchgeschaeft'
})
export class KompaktGrundbuchgeschaeftPipe extends KompaktdarstellungPipe<GrundbuchgeschaeftItem> {
  constructor(
    protected formatConfigService: FormatConfigService,
    protected location: PlatformLocation,
    protected kompaktLocation: ComponentLocationStrategy,
    private translate: TranslateService,
    private formatTimepointPipe: FormatTimepointPipe,
    private datumPipe: DatumPipe
  ) {
    super(formatConfigService, 'GRUNDBUCHGESCHAEFT', location, kompaktLocation);
  }

  private static isDefined = function (val) {
    return val;
  };

  transform(item: GrundbuchgeschaeftItem): string {
    const eingangTagebuch = this.datumPipe.transform(item.eingangTagebuch);
    const timepoint = this.formatTimepointPipe.transform(item.timePoint);
    const delimiter = ' ';
    let text: string;
    if (this.formatElement === 'GRUNDBUCHGESCHAEFT_TYP00') {
      text = timepoint;
    }
    if (this.formatElement === 'GRUNDBUCHGESCHAEFT_TYP01') {
      text = [eingangTagebuch, timepoint].filter(KompaktGrundbuchgeschaeftPipe.isDefined).join(delimiter);
    }
    if (this.formatElement === 'GRUNDBUCHGESCHAEFT_TYP02') {
      const status = this.translate.instant(item.status);
      text = [eingangTagebuch, timepoint, status].filter(KompaktGrundbuchgeschaeftPipe.isDefined).join(delimiter);
    }
    return text;
  }
}
